// removed by extract-text-webpack-plugin
module.exports = {"matrixSignUpLink":"MatrixPageFooter__matrixSignUpLink___HR7HC"};